__turbopack_context__.v({
  "checkbox": "xQcA_a_checkbox",
  "checkboxSelected": "xQcA_a_checkboxSelected",
  "listWrapper": "xQcA_a_listWrapper",
  "listWrapperGhost": "xQcA_a_listWrapperGhost",
  "listWrapperOpen": "xQcA_a_listWrapperOpen",
  "listbox": "xQcA_a_listbox",
  "option": "xQcA_a_option",
  "optionLarge": "xQcA_a_optionLarge",
  "optionMedium": "xQcA_a_optionMedium",
  "optionMultiple": "xQcA_a_optionMultiple",
  "optionSelected": "xQcA_a_optionSelected",
});
